import { useEffect, useState } from "react";

import { Modal, ModalBody, ModalHeader } from "reactstrap";

import EyeIcon from "../../components/EyeIcon";
import PaymentDetails from "../Payments/Details";
import * as _service from "../../service/customer.service";

import { dateConverter, numberToCurrency } from "../../helpers/functions";
import { handlePrint } from "./helper";
import { FaFileDownload, FaUser, FaPhone } from "react-icons/fa";

const Details = ({ isOpen, onToggle, id }) => {
  const [data, setData] = useState({});
  const [modalData, setModalData] = useState({ show: false });

  useEffect(() => {
    if (isOpen && id) handleData();
  }, [isOpen, id]); // eslint-disable-line

  const handleData = async () => {
    try {
      const response = await _service.details(id);
      let { data } = response;

      if (!Array.isArray(data.payments)) data.payments = [];

      let totalAmount = 0;
      let dueAmount = 0;

      data.payments.map((item, index) => {
        item.id = index + 1;
        item.date = dateConverter(item.date);

        totalAmount += Number(item.amount || 0) || 0;
        dueAmount += Number(item.dueAmount || 0) || 0;

        return item;
      });

      setData({ ...data, totalAmount, dueAmount });
    } catch (error) {
      console.error(error);
      onToggle();
    }
  };

  const handleToggle = ({ show = false, id } = {}) => {
    setModalData({ show, id });
  };

  return (
    <Modal isOpen={isOpen} centered size="lg" toggle={onToggle}>
      <ModalHeader toggle={onToggle} className="border-bottom-0 pb-0">
        <span className="fw-bold text-dark fs-5">Customer Profile - {data.name || ""}</span>
      </ModalHeader>
      <ModalBody className="bg-light p-3 rounded-bottom">
        <div className="card border-0 shadow-sm bg-white mb-3">
          <div className="card-body p-3">
            <div className="d-flex align-items-center gap-2 mb-3 pb-2 border-bottom text-primary fw-bold small text-uppercase" style={{ letterSpacing: "0.5px" }}>
              <FaUser /> Customer details
            </div>
            
            <div className="row g-3">
              <div className="col-md-6">
                <div className="d-flex flex-column gap-3">
                  <div className="d-flex align-items-center gap-3">
                    <div className="rounded-circle bg-light d-flex align-items-center justify-content-center" style={{ width: "36px", height: "36px", color: "#006aae", flexShrink: 0 }}>
                      <FaUser />
                    </div>
                    <div>
                      <small className="text-muted d-block" style={{ fontSize: "11px" }}>Customer Name</small>
                      <span className="fw-semibold text-dark">{data.name || "-"}</span>
                    </div>
                  </div>

                  <div className="d-flex align-items-center gap-3">
                    <div className="rounded-circle bg-light d-flex align-items-center justify-content-center" style={{ width: "36px", height: "36px", color: "#006aae", flexShrink: 0 }}>
                      <FaPhone />
                    </div>
                    <div>
                      <small className="text-muted d-block" style={{ fontSize: "11px" }}>Mobile Number</small>
                      <span className="fw-semibold text-dark">{data.mobile || "-"}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="d-flex flex-column gap-2 p-3 bg-light rounded border border-light h-100 justify-content-center">
                  <div className="d-flex justify-content-between align-items-center border-bottom pb-2">
                    <span className="text-muted small">Total Billing</span>
                    <span className="fw-bold text-success fs-6">{data.totalAmount?.toFixed(2) || "0.00"}</span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center pt-1">
                    <span className="text-muted small">Remaining Balance</span>
                    <span className={`fw-bold fs-6 ${Number(data.dueAmount || 0) > 0 ? "text-danger" : "text-success"}`}>
                      {data.dueAmount?.toFixed(2) || "0.00"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card border-0 shadow-sm mt-3 bg-white">
          <div className="card-body p-3">
            <h6 className="fw-bold text-dark mb-3 small text-uppercase" style={{ letterSpacing: "0.5px" }}>Job &amp; Payment Records</h6>
            
            <div className="table-responsive rounded border">
              <table className="table table-hover align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th className="text-center" style={{ width: "50px" }}>#</th>
                    <th>Date</th>
                    <th>Boat Name</th>
                    <th className="text-end">Total Amount</th>
                    <th className="text-end">Due Amount</th>
                    <th className="text-center" style={{ width: "80px" }}>Actions</th>
                  </tr>
                </thead>
                <tbody className="small">
                  {data.payments?.map((item) => (
                    <tr key={item.id} className="position-relative">
                      <td className="text-muted text-center">{item.id}</td>
                      <td className="text-muted">{item.date}</td>
                      <td className="fw-medium text-dark">{item.boat || "-"}</td>
                      <td className="text-end fw-semibold text-dark">
                        {numberToCurrency(item.amount)}
                      </td>
                      <td
                        className={`text-end fw-semibold ${
                          item.dueAmount > 0 ? "text-danger" : "text-success"
                        }`}
                      >
                        {numberToCurrency(item.dueAmount)}
                      </td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <EyeIcon onClick={() => handleToggle({ show: true, id: item._id })} />
                        </div>
                      </td>
                    </tr>
                  ))}
                  {!data.payments?.length && (
                    <tr>
                      <td colSpan="6" className="text-center p-3 text-muted">No records found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-end mt-4 gap-3">
          <button className="btn btn-reset" onClick={onToggle}>
            Close
          </button>
          <button className="btn btn-submit" onClick={() => handlePrint(data)}>
            <FaFileDownload className="me-2" /> Share
          </button>
        </div>
      </ModalBody>
      <PaymentDetails {...modalData} isOpen={modalData.show} onToggle={() => handleToggle()} />
    </Modal>
  );
};

export default Details;
